import React from "react";
import * as css from "./BigTitle.module.scss";
import { Link } from "gatsby";

type prop = {
  onCloseEntrance: () => {};
  lang: "en" | "ja";
};

const BigTitle: React.FC<prop> = (prop) => {
  return (
    <div className={css.base} lang={`en`}>
      <h1 className={css.title}>
        LIMINAL SPACE,
        <br />
        WORLD WIDE <br />
        REPORT
      </h1>
      <div className={css.sub}>
        <div className={css.sub__inner}>
          <h2>
            <span className={css.date}>
              Jan.–Feb., 2021
            </span>
            <br />
            SEIRA UCHIDA &<br />
            TERESA FELDMANN
          </h2>
          <p>SUPPORT BY AIT & BALTAN LABORATORIES</p>
        </div>
      </div>
      <button
        className={css.transparentEnterButton}
        onClick={prop.onCloseEntrance}
      />

      {/*<div className={css.borderWrap}>*/}
      {/*    <div />*/}
      {/*    <div />*/}
      {/*    <div />*/}
      {/*    <div />*/}
      {/*</div>*/}
    </div>
  );
};

export default BigTitle;
